import { useCallback } from "react";

import { trpc, trpcUtils } from "@editor/utils/trpc";

import toast from "@replo/design-system/components/alert/Toast";

type ShopUpdateNameProps = {
  id: string;
  name: string;
  showSuccessToast?: boolean;
};

export function useUpdateShop() {
  const { mutateAsync: updateProjectName, isPending } =
    trpc.project.updateName.useMutation({
      onSuccess: () => {
        void trpcUtils.workspace.getUserWorkspacesList.invalidate();
        void trpcUtils.project.listWithStats.invalidate();
        void trpcUtils.project.listGroupedByWorkspaceForUser.invalidate();
        void trpcUtils.project.get.invalidate();
      },
    });

  const updateShopName = useCallback(
    async ({ id, name, showSuccessToast = true }: ShopUpdateNameProps) => {
      const result = await updateProjectName(
        {
          projectId: id,
          name: name,
        },
        {
          onSuccess: () => {
            if (showSuccessToast) {
              toast({
                header: "Project Name Updated",
                message: `Project name has been changed to "${name}".`,
              });
            }
          },
        },
      );

      return result;
    },
    [updateProjectName],
  );

  return {
    updateShopName,
    isUpdating: isPending,
  };
}
